import { type TRenderReactApp, type TUpdateReactApp } from './renderer';
import { FabricComponent, TOnRenderedCallback } from './fabricComponent';
import config, { FORCE_HYDRATION_MFES } from '../../mfe.config';

const {
    customElement: { name },
} = config;

export default function defineCustomElement(
    renderApp: TRenderReactApp,
    updateApp: TUpdateReactApp,
    onRenderedCallback?: TOnRenderedCallback
) {
    if (!customElements.get(name)) {
        customElements.define(
            name,
            class extends FabricComponent {
                constructor() {
                    super(
                        renderApp,
                        updateApp,
                        onRenderedCallback,
                        FORCE_HYDRATION_MFES
                    );
                }
            }
        );
    }
}
